export const ROUTE_CREATE = 'create';
export const ROUTE_MODIFY = 'modify';
